import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPutRelationship {

  constructor(
    public uid: string,
    public name: string = null,
    public description: string = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutRelationship(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
